import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import config from '../config';

const API = config.API_URL;

function inr(n) {
  const v = Number(n);
  if (!v && v !== 0) return '—';
  return `₹${Math.round(v).toLocaleString('en-IN')}`;
}

function PawnBusinessAnalysis() {
  const [months, setMonths] = useState(6);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/pawn/analytics?months=${months}`);
      setData(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [months]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
        <div>
          <h2 className="h4 mb-0"><i className="bi bi-graph-up me-2" />Pawn Business Analysis</h2>
          <small className="text-muted">Interest profit + late fees</small>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <select className="form-select form-select-sm" value={months} onChange={(e) => setMonths(Number(e.target.value))}>
            <option value={3}>3 months</option>
            <option value={6}>6 months</option>
            <option value={12}>12 months</option>
          </select>
          <Link to="/pawn" className="btn btn-sm btn-outline-primary">Pawn counter</Link>
        </div>
      </div>

      {loading && <div className="text-center py-5"><div className="spinner-border" /></div>}

      {!loading && data && (
        <>
          <div className="row g-2 mb-4">
            <div className="col-md-3">
              <div className="card h-100 border-primary">
                <div className="card-body">
                  <div className="text-muted small">Active abhi</div>
                  <div className="fs-3 fw-bold">{data.activeNow}</div>
                  <div className="small">Cash at risk: {inr(data.cashAtRisk)}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card h-100">
                <div className="card-body">
                  <div className="text-muted small">Nayi girvi (period)</div>
                  <div className="fs-3 fw-bold">{data.totals.newPledges}</div>
                  <div className="small">Disbursed: {inr(data.totals.disbursed)}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card h-100">
                <div className="card-body">
                  <div className="text-muted small">Redeemed</div>
                  <div className="fs-3 fw-bold">{data.totals.redeemed}</div>
                  <div className="small">Sold: {data.totals.sold || 0} · recovery {inr(data.totals.soldRecovery)}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card h-100 border-success">
                <div className="card-body">
                  <div className="text-muted small">Total profit</div>
                  <div className="fs-3 fw-bold text-success">{inr(data.totals.totalProfit)}</div>
                  <div className="small">Byaj: {inr(data.totals.interestProfit)} · Late: {inr(data.totals.lateFeeIncome)}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>New pledges</th>
                  <th>Disbursed</th>
                  <th>Redeemed</th>
                  <th>Sold</th>
                  <th>Sale recovery</th>
                  <th>Interest profit</th>
                  <th>Late fees</th>
                  <th>Total profit</th>
                </tr>
              </thead>
              <tbody>
                {(data.monthly || []).map((m) => (
                  <tr key={m.month}>
                    <td>{m.month}</td>
                    <td>{m.newPledges}</td>
                    <td>{inr(m.disbursed)}</td>
                    <td>{m.redeemed}</td>
                    <td>{m.sold || 0}</td>
                    <td>{inr(m.soldRecovery)}</td>
                    <td>{inr(m.interestProfit)}</td>
                    <td>{inr(m.lateFeeIncome)}</td>
                    <td className="fw-semibold">{inr(m.totalProfit)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default PawnBusinessAnalysis;
